// extracted by mini-css-extract-plugin
export default {"attachmentButton":"ExpenseTableWithAView_attachmentButton__awQ+e"};